<template>
  <div class="mt-10">
    <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
      정품 인증시 회원등급 자동변경 설정
    </p>

    <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
      고객이 정품 인증시 특정 회원등급으로 자동 변경할 수 있습니다. <br />
      정품 인증 설정 탭에 있는 '정품 인증 관리자 승인 설정'을 사용하시는 경우, 관리자가 승인완료시 회원등급이 자동 변경되오니 참고해주세요.
    </p>

    <div>
      <v-btn small color="black" class="white--text mr-3 mt-4" @click.prevent="memberLevelListShow()">변경할 회원등급 선택</v-btn>

      <v-card v-for="(group, index) in groups" :key="index" width="840" outlined class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3">
        <div style="width: 100%;">
          <div style="width: 100%; display: flex;">
            <v-card-text class="pa-0">
              <div class="float-left">
                <div style="font-size:1rem;" class="py-4 px-6">
                  <font v-if="group.type == 'product' && group.product_name" class="primary--text font-weight-bold">
                    {{ group.product_name }}
                  </font>
                  정품 인증이 완료되면
                  <font class="mt-4 mb-0 primary--text font-weight-bold"> [{{ group.group_name }}] 등급으로 </font>
                  변경합니다.
                </div>
              </div>
              <div class="float-right">
                <v-btn small color="grey lighten-1" class="white--text mr-3 mt-3" @click.prevent="memberLevelDelete(index)"
                  >설정 삭제</v-btn
                >
              </div>
            </v-card-text>
          </div>

          <div v-if="group.group_exception_list.length > 0" style="width: 100%;">
            <v-card-text class="pa-0 d-flex mb-3">
              <div class="float-left pr-5 pl-6" style="width: 100%;">
                <div>
                  <p class="mb-0 float-left mr-2" style="color:#f1c40f;">
                    - 적용제외 회원등급 :
                  </p>
                  <div v-for="(exception, index) in group.group_exception_list" :key="exception.group_no" class="float-left d-flex">
                    <p class="mb-0" style="color:#f1c40f;">
                      {{ exception.group_name }}
                    </p>
                    <p v-if="index < group.group_exception_list.length - 1" class="mb-0 mr-2" style="word-break:break-all; color:#f1c40f;">
                      ,
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </div>
          <div>
            <v-btn small color="#f1c40f" class="white--text mx-6 mb-4" @click.prevent="exceptionGroups(index)"
              >적용제외 회원등급 설정</v-btn
            >
          </div>
        </div>
      </v-card>

      <v-card v-if="groups.length == 0" width="840" outlined class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3">
        <v-card-text class="pa-0">
          <div>
            <p class="mt-3 mb-3 ml-5">
              설정한 회원등급이 없습니다.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <!-------------------------->
    <p class="mt-15 mb-0 title font-weight-light font-weight-bold">
      정품 인증시 적립금 자동지급 설정
    </p>

    <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
      고객이 정품 인증시 자동으로 적립금(포인트)를 지급할 수 있습니다. <br />
      정품 인증 설정 탭에 있는 '정품 인증 관리자 승인 설정'을 사용하시는 경우, 관리자가 승인완료시 적립금이 자동 지급되오니 참고해주세요.
    </p>
    <div>
      <v-btn small color="black" class="white--text mr-3 mt-4" @click.prevent="mileageShow()">적립금 설정</v-btn>

      <v-card v-for="(mileage, index) in mileages" :key="index" width="840" outlined class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3">
        <div style="width: 100%;">
          <div style="width: 100%; display: flex;">
            <v-card-text class="pa-0">
              <div class="float-left">
                <div style="font-size:1rem;" class="py-4 px-6">
                  <font v-if="mileage.type == 'product' && mileage.product_name" class="primary--text font-weight-bold">
                    {{ mileage.product_name }}
                  </font>
                  정품 인증이 완료되면
                  <font class="mt-4 mb-0 primary--text font-weight-bold"> [적립금 {{ mileage.mileage | numberFormat }}원] </font>
                  을 지급합니다.
                </div>
              </div>
              <div class="float-right">
                <v-btn small color="grey lighten-1" class="white--text mr-3 mt-3" @click.prevent="mileageDelete(index)">설정 삭제</v-btn>
              </div>
            </v-card-text>
          </div>

          <div v-if="mileage.mileage_exception_list.length > 0" style="width: 100%;">
            <v-card-text class="pa-0 d-flex mb-3">
              <div class="float-left pr-5 pl-6" style="width: 100%;">
                <div>
                  <p class="mb-0 float-left mr-2" style="color:#f1c40f;">
                    - 적용제외 회원등급 :
                  </p>
                  <div v-for="(exception, index) in mileage.mileage_exception_list" :key="exception.group_no" class="float-left d-flex">
                    <p class="mb-0" style="color:#f1c40f;">
                      {{ exception.group_name }}
                    </p>
                    <p
                      v-if="index < mileage.mileage_exception_list.length - 1"
                      class="mb-0 mr-2"
                      style="word-break:break-all; color:#f1c40f;"
                    >
                      ,
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </div>
          <div>
            <v-btn small color="#f1c40f" class="white--text mx-6 mb-4" @click.prevent="exceptionMileage(index)"
              >적용제외 회원등급 설정</v-btn
            >
          </div>
        </div>
      </v-card>

      <v-card v-if="mileages.length == 0" width="840" outlined class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3">
        <v-card-text class="pa-0">
          <div>
            <p class="mt-3 mb-3 ml-5">
              설정된 적립금 발급이 없습니다.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!----------------->

    <p class="mt-15 mb-0 title font-weight-light font-weight-bold">
      정품 인증시 쿠폰 자동발급 설정
    </p>

    <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
      <span v-if="mallType !== 'imweb'">
        고객이 정품 인증시 카페24 관리자에 설정된 쿠폰 발급이 최대 5개까지 가능합니다.<br />
        발급구분 '대상자 지정 발급' - 발급시점 '즉시 발급'으로 설정된 쿠폰만 발급이 가능합니다.<br />
      </span>
      <span v-if="mallType === 'imweb'">
        고객이 정품 인증시 쇼핑몰 관리자에 설정된 쿠폰 발급이 가능합니다.<br />
        발급되는 쿠폰 형식은 ‘고객 다운로드’ 설정된 쿠폰만 발급할 수 있습니다.<br />
      </span>
      정품 인증 설정 탭에 있는 '정품 인증 관리자 승인 설정'을 사용하시는 경우, 관리자가 승인완료시 쿠폰이 자동 발급되오니 참고해주세요.
    </p>

    <div>
      <v-btn small color="black" class="white--text mr-3 mt-4" @click.prevent="couponShow()">
        <span v-if="['mall', 'cafe24'].includes(mallType)">카페24</span> 쿠폰 선택</v-btn
      >

      <v-card v-for="(coupon, index) in coupons" :key="index" width="840" outlined class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3">
        <div style="width: 100%;">
          <div style="width: 100%; display: flex;">
            <v-card-text class="pa-0">
              <div class="float-left">
                <div style="font-size:1rem;" class="py-4 px-6">
                  <font v-if="coupon.type == 'product' && coupon.product_name" class="primary--text font-weight-bold">
                    {{ coupon.product_name }}
                  </font>
                  정품 인증이 완료되면
                  <font class="mt-4 mb-0 primary--text font-weight-bold"> [{{ coupon.coupon_name }}] </font>
                  쿠폰을 발급합니다.
                </div>
              </div>
              <div class="float-right">
                <v-btn small color="grey lighten-1" class="white--text mr-3 mt-3" @click.prevent="couponDelete(index)">설정 삭제</v-btn>
              </div>
            </v-card-text>
          </div>

          <div v-if="coupon.coupon_exception_list.length > 0" style="width: 100%;">
            <v-card-text class="pa-0 d-flex mb-3">
              <div class="float-left pr-5 pl-6" style="width: 100%;">
                <div>
                  <p class="mb-0 float-left mr-2" style="color:#f1c40f;">
                    - 적용제외 회원등급 :
                  </p>
                  <div v-for="(exception, index) in coupon.coupon_exception_list" :key="exception.group_no" class="float-left d-flex">
                    <p class="mb-0" style="color:#f1c40f;">
                      {{ exception.group_name }}
                    </p>
                    <p
                      v-if="index < coupon.coupon_exception_list.length - 1"
                      class="mb-0 mr-2"
                      style="word-break:break-all; color:#f1c40f;"
                    >
                      ,
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </div>
          <div>
            <v-btn small color="#f1c40f" class="white--text mx-6 mb-4" @click.prevent="exceptionCoupons(index)"
              >적용제외 회원등급 설정</v-btn
            >
          </div>
        </div>
      </v-card>

      <v-card v-if="coupons.length == 0" width="840" outlined class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3">
        <v-card-text class="pa-0">
          <div>
            <p class="mt-3 mb-3 ml-5">
              설정된 쿠폰이 없습니다.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <div class="d-flex justify-center align-center mt-0" style="width:840px;">
      <v-btn large color="primary" class="saveBtn" @click="warrantyBenefitSave()">저장</v-btn>
    </div>
    <MemberLevelList ref="MemberLevelList"></MemberLevelList>
    <ExceptionCommon ref="ExceptionGroups" :config="groupExceptionConfig"></ExceptionCommon>
    <MileageSetting ref="MileageSetting"></MileageSetting>
    <ExceptionCommon ref="ExceptionMileage" :config="mileageExceptionConfig"></ExceptionCommon>
    <CouponSetting ref="CouponSetting"></CouponSetting>
    <ExceptionCommon ref="ExceptionCoupon" :config="couponExceptionConfig"></ExceptionCommon>
  </div>
</template>

<style scoped>
.saveBtn {
  color: unset;
  text-decoration: none;
  width: 200px;
}

.mt-15 {
  margin-top: 60px !important;
}
</style>
<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import MemberLevelList from "@/components/authservice/warranty_period/modal/MemberLevelList.vue";
import ExceptionCommon from "@/components/authservice/warranty_period/modal/ExceptionCommon.vue";
import MileageSetting from "@/components/authservice/warranty_period/modal/MileageSetting.vue";
import CouponSetting from "@/components/authservice/warranty_period/modal/CouponSetting.vue";

import Filters from "@/libs/authservice/filters.js";
export default {
  data: () => ({
    M,
    AUTH_SERVICE,
    groups: [],
    mileages: [],
    coupons: [],
    product_items: [],
    serialProductList: [],
    get_product_time: null,
    // 공통 모달 설정
    groupExceptionConfig: {
      type: "group",
      title: "자동 변경 제외 회원등급 설정",
      description: "선택한 회원등급은 정품 인증시 자동 변경하지 않습니다.",
      exceptionListKey: "group_exception_list",
      parentMethodName: "setGroupExceptionList",
    },
    mileageExceptionConfig: {
      type: "mileage",
      title: "적립금 지급 제외 회원등급 설정",
      description: "선택한 회원등급은 정품 인증시 적립금이 지급되지 않습니다.",
      exceptionListKey: "mileage_exception_list",
      parentMethodName: "setMileageExceptionList",
    },
    couponExceptionConfig: {
      type: "coupon",
      title: "쿠폰 발급 제외 회원등급 설정",
      description: "선택한 회원등급은 정품 인증시 쿠폰이 발급되지 않습니다.",
      exceptionListKey: "coupon_exception_list",
      parentMethodName: "setCouponExceptionList",
    },
  }),
  filters: Filters,
  mixins: [CommonMixin],
  methods: {
    reset: function() {
      Object.assign(this.$data, this.$options.data());
    },
    memberLevelListShow: async function() {
      this.$refs.MemberLevelList.show();
    },
    memberLevelDelete: function(index) {
      if (confirm("설정한 회원등급을 삭제하시겠습니까?")) {
        this.groups.splice(index, 1);
      }
    },
    exceptionGroups: async function(index) {
      this.$refs.ExceptionGroups.show(this.groups[index], index);
    },
    setGroupExceptionList: async function(params, index) {
      this.groups[index].group_exception_list = [];
      this.groups[index].group_exception_list = params;
    },
    warrantyBenefitSave: async function() {
      await M.api(M.entry("/put/config/groups"), this.groups);
      await M.api(M.entry("/put/config/mileage"), this.mileages);
      await M.api(M.entry("/put/config/coupons"), this.coupons);
      this.alertShow("저장되었습니다.");
    },
    getGroups: async function() {
      try {
        this.groups = await M.api(M.entry("/get/config/groups"));
      } catch (e) {
        console.log(e);
      }
    },

    getMileages: async function() {
      try {
        this.mileages = await M.api(M.entry("/get/config/mileage"));
      } catch (e) {
        console.log(e);
      }
    },

    getCoupons: async function() {
      try {
        this.coupons = await M.api(M.entry("/get/config/coupons"));
        console.log(this.coupons);
      } catch (e) {
        console.log(e);
      }
    },

    getSerialProducts: async function(get_type) {
      try {
        const now = new Date();
        if (!this.get_product_time || now - this.get_product_time > 5 * 60 * 1000) {
          this.get_product_time = now;
          this.serialProductList = await M.api(M.entry("/get/serials/products"));

          for (const product of this.serialProductList) {
            let find_product = null;
            if (get_type === "coupon") {
              find_product = this.coupons.find((e) => Number(e.product_no) == Number(product.product_no));
            } else if (get_type === "mileage") {
              if (this.mileages.length > 0) {
                find_product = this.mileages.find((e) => Number(e.product_no) == Number(product.product_no));
              }
            } else if (get_type === "group") {
              find_product = this.groups.find((e) => Number(e.product_no) == Number(product.product_no));
            }
            if (find_product) {
              continue;
            }
            this.product_items.push(product);
          }
        }
        return this.product_items;
      } catch (e) {
        console.log("get product error", e);
        alert("조회되지 않았습니다.");
      }
    },

    mileageShow: async function() {
      this.$refs.MileageSetting.show();
    },

    mileageDelete: function(index) {
      if (confirm("설정한 적립금 설정을 삭제하시겠습니까?")) {
        this.mileages.splice(index, 1);
      }
    },
    exceptionMileage: async function(index) {
      this.$refs.ExceptionMileage.show(this.mileages[index], index);
    },
    setMileageExceptionList: async function(params, index) {
      this.mileages[index].mileage_exception_list = [];
      this.mileages[index].mileage_exception_list = params;
    },

    couponShow: async function() {
      this.$refs.CouponSetting.show();
    },

    couponDelete: function(index) {
      if (confirm("설정한 쿠폰 설정을 삭제하시겠습니까?")) {
        this.coupons.splice(index, 1);
      }
    },
    exceptionCoupons: async function(index) {
      this.$refs.ExceptionCoupon.show(this.coupons[index], index);
    },
    setCouponExceptionList: async function(params, index) {
      this.coupons[index].coupon_exception_list = [];
      this.coupons[index].coupon_exception_list = params;
    },
  },
  created: async function() {
    this.reset();
    await this.getGroups();
    await this.getMileages();
    await this.getCoupons();
  },
  computed: {
    mallType: function() {
      return this.$store.state.mallType;
    },
  },
  components: {
    MemberLevelList,
    ExceptionCommon,
    MileageSetting,
    CouponSetting,
  },
};
</script>
